import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const defaultVideoLinks = [
  {
    title: "Step 1: Device Setup",
    href: "/wificonnect.mp4",
  },
  {
    title: "Step 2: App Connection",
    href: "https://example.com/video-2",
  },
  {
    title: "Step 3: Account Activation",
    href: "https://example.com/video-3",
  },
  {
    title: "Step 4: First Study Sync",
    href: "https://example.com/video-4",
  },
];

export default function ActivationSteps() {
  const navigate = useNavigate();
  const [videoLinks, setVideoLinks] = useState(defaultVideoLinks);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/videos/")
      .then((res) => res.ok ? res.json() : Promise.reject("Failed to fetch"))
      .then((list) => {
        if (Array.isArray(list) && list.length > 0) {
          const fetchedLinks = list.map((item) => ({
            title: item.title,
            href: item.url,
          }));

          setVideoLinks([
            defaultVideoLinks[0],
            ...defaultVideoLinks.slice(1).map((defaultVideo, index) => (
              fetchedLinks[index + 1] ?? defaultVideo
            )),
          ]);
        }
      })
      .catch((err) => {
        console.warn("Problem loading video list, using defaults", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 px-4 py-10">
      <div className="mx-auto max-w-4xl">
        <div className="flex items-center justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-slate-500 uppercase">
              PENSENSE
            </p>
            <h1 className="mt-3 text-3xl font-semibold tracking-tight">
              Activation Steps
            </h1>
            <p className="mt-2 text-sm text-slate-400 max-w-2xl">
              Follow these videos to complete setup and start using your pen
              smoothly.
            </p>
            {loading && (
              <p className="mt-2 text-sm text-yellow-300">Loading video list...</p>
            )}
          </div>
          <button
            onClick={() => navigate(-1)}
            type="button"
            className="inline-flex items-center rounded-xl border border-slate-700 bg-slate-900/70 px-4 py-2 text-sm text-slate-200 transition hover:bg-slate-800"
          >
            Back
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {videoLinks.map((video, index) => (
            <a
              key={video.title}
              href={video.href}
              target="_blank"
              rel="noreferrer"
              className="group rounded-2xl border border-slate-800 bg-slate-900/70 p-5 shadow-[0_18px_45px_rgba(15,23,42,0.65)] transition hover:border-sky-500/50 hover:bg-slate-900"
            >
              <p className="text-xs font-semibold tracking-[0.2em] text-sky-300 uppercase">
                Video {index + 1}
              </p>
              <h2 className="mt-3 text-lg font-semibold text-slate-50">
                {video.title}
              </h2>
              <p className="mt-2 text-sm text-slate-400">
                Open the video guide in a new tab.
              </p>
              <span className="mt-4 inline-flex text-sm font-medium text-sky-300 group-hover:text-sky-200">
                Watch video
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
